export default __webpack_public_path__ + "static/media/img-soon-grid.8ee79240.svg";